module.exports = __webpack_public_path__ + "img/cloud.18dbc91f.png";